export function updateSignalsGroupAlgoListData(
  state,
  updatedData = [],
  newDataToInsert = []
) {
  const oldData = state?.data?.data || [];

  const newData = [...oldData, ...newDataToInsert];

  for (let index = 0; index < updatedData.length; index++) {
    const updatedDataElement = updatedData[index];
    const targetDataIndex = newData.findIndex(
      (item) => item._id === updatedDataElement._id
    );

    if (targetDataIndex < 0) {
      continue;
    }

    newData[targetDataIndex] = {
      ...newData[targetDataIndex],
      ...updatedDataElement,
    };
  }

  const fullTableData = {
    ...state?.data,
    data: [...newData],
  };

  return fullTableData;
}

export function updateSignalsGroupLinkedAlgosData(state, linkedAlgos = []) {
  const oldData = state?.data?.data || [];

  const newData = oldData.map((item) => {
    if (linkedAlgos.includes(item._id)) {
      item.selected = true;
    } else {
      item.selected = false;
    }

    return item;
  });

  const fullTableData = {
    ...state?.data,
    data: [...newData],
  };

  return fullTableData;
}

export const updateSignalGroupAlgoDetails = (
  state,
  algoId,
  updatedData = {}
) => {
  const oldData = state?.data?.data || [];
  const newData = JSON.parse(JSON.stringify(oldData));

  const targetDataIndex = newData.findIndex((item) => item._id === algoId);

  if (targetDataIndex >= 0) {
    newData[targetDataIndex] = {
      ...newData[targetDataIndex],
      ...updatedData,
    };
  }

  const fullTableData = {
    ...state?.data,
    data: [...newData],
  };

  return fullTableData;
};

export const updateSignalGroupAlgoHealthStatus = (state, algos = []) => {
  const oldData = state?.data?.data || [];
  const newData = JSON.parse(JSON.stringify(oldData));

  for (let index = 0; index < newData.length; index++) {
    const element = newData[index];
    const targetAlgoFeed = algos.find((item) => item.id === element._id);

    if (targetAlgoFeed?.status) {
      newData[index].algoStatus = targetAlgoFeed?.status;
    }
  }

  console.log(newData);

  const fullTableData = {
    ...state?.data,
    data: [...newData],
  };

  return fullTableData;
};
